@if (showSuggestedRetailPrice) {
  @if (priceItem && priceItem.retailNetPrice > 0) {
    {{ ('BAG.PRICE.RETAIL' | translate) }}
    {{priceItem.RetailCurrencyCode.toUpperCase()}}
    {{priceItem.retailNetPrice | number : '1.2-2' : currentLanguage}}
  }
  @if (priceItem && priceItem.retailNetPrice <= 0) {
    {{ ('BAG.GET.PRICE.NON.FOUND' | translate) }}
  }
}